import React, { useMemo } from 'react';
import { FaChevronRight, FaBars } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import './MobileCategoryBar.scss';

const MobileCategoryBar = ({ onClick }) => {
  const selectedCategory = useSelector((state) => state.categories.selectedCategory);
  
  const categories = useSelector((state) => state.categories.entities) || [];
  
  const categoryName = useMemo(() => {
    return selectedCategory ? categories?.find((cat) => cat.id === selectedCategory)?.name : 'Home';
  }, [selectedCategory, categories]);
//   const categoryName = selectedCategory 
//     ? categories[selectedCategory]?.name || 'Loading...'
//     : 'Home';

  return (
    <div className="mobile-category-bar" onClick={onClick}>
      <FaBars />
      <div className="category-name">{categoryName}</div>
      {/* <div className="category-arrow">
        <FaChevronRight />
      </div> */}
    </div>
  );
};

export default MobileCategoryBar;